import { Injectable } from '@angular/core';
import { Settings } from './app.settings.model';

@Injectable()
export class AppSettings {
    public settings = new Settings(
        'Impac',       //theme name
        true,           //loadingSpinner
        true,           //fixedHeader
        true,           //sidenavIsOpened
        true,           //sidenavIsPinned  
        false,           //sidenavUserBlock 
        'vertical',     //horizontal , vertical
        'default',      //default, compact, mini
        'blue-dark', //indigo-light, teal-light, red-light, blue-dark, green-dark, pink-dark
        false,          // true = rtl, false = ltr
        false           // true = has footer, false = no footer
    )
}

